const genAnswer = function (qu, value, refItem) {
  value = value.split(',')
  return [{
    descId: qu.id,
    answer1: value[0] || '',
    answer2: value[1] || '',
    answer3: value[2] || '',
    otherAnswer: qu.otherAnswer || ''
  }]
}

const setAnswer = function (qu, valueMap, otherAnswerMap, extendsDataMap) {
  const id = qu.id
  let value = valueMap[id] || ''
  qu.value = value
  qu.otherAnswer = otherAnswerMap[id] || ''
}

const answer = {
  genAnswer,
  setAnswer
}

export default answer



// WEBPACK FOOTER //
// ./src/components/editor/SelectBox/answer.js